// Vendor
import { Component, OnInit, AfterViewChecked, Inject, LOCALE_ID } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { fromEvent } from "rxjs";
import { environment } from "../environments/environment";

// App
import { PricesService } from "./services/prices/prices.service";
import { OrderService } from "./services/order/order.service";
import { FrameService, FramePostPayload } from "./services/frame/frame.service";

@Component({
    selector: "ig-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, AfterViewChecked {
    public showNav = false;
    public showFrameIndicator = false;
    public frameIndicatorHeight: number;

    //
    // Observables
    // =========================================================================
    private winResize$ = fromEvent(window, "resize");
    private winResize$Subs = this.winResize$.subscribe(
        this.frameService.resize.emit.bind(this.frameService.resize)
    );

    constructor(
        public pricesService: PricesService,
        public orderService: OrderService,
        private frameService: FrameService,
        private router: Router,

        @Inject(LOCALE_ID)
        private readonly locale: "nl" | "fr",
    ) { }

    private onWinResize(): void {
        this.frameService.resize.emit();
    }

    ngOnInit() {
        this.initGa();
        // Debugging tool to show what the height of the iframe shoudl be when
        // this application is embedded in an iframe.
        if (this.orderService.useEphemeralStorage === false) {
            this.showFrameIndicator = true;

            this.frameService.posted.subscribe((event: FramePostPayload) => {
                this.frameIndicatorHeight = event.height;
            });
        }

        this.router.events.subscribe(event => {
            if (this.showNav === false && event instanceof NavigationEnd) {
                this.showNav = true;
            }
            this.frameService.reset.emit();

            if (event instanceof NavigationEnd) {
                this.doGa(event.urlAfterRedirects);
            }
        });

        switch (this.locale) {
            case "nl":
                document.title = "Adviesgesprek isolatie";
                break;
            case "fr":
                document.title = "Demande de rendez-vous avec le conseiller isolation";
                break;
        }
    }

    ngAfterViewChecked() {
        this.frameService.resize.emit();
    }

    initGa() {
        if (environment.gaCode) {
            (window as any).ga("create", environment.gaCode, "auto");
        }
    }

    doGa(url) {
        if (environment.gaCode) {
            (window as any).ga("set", "page", url);
            (window as any).ga("send", "pageview");
        }
    }
}
